import { CLARIFICATION_STAKEHOLDERS_RESOURCE } from './clarification.stakeholders.resource';

export const CASETAFEL_STAKEHOLDERS_RESOURCE = {
  key: 'CASETAFEL_STAKEHOLDERS_RESOURCE',
  ...CLARIFICATION_STAKEHOLDERS_RESOURCE
};
